import { observable, action } from 'mobx';
import { Decisions } from 'api';

class DecisionStore {
  @observable decision;

  @observable fetchState;

  @action.bound
  async getDecision(anketId, decisionId) {
    this.fetchState = 'pending';

    try {
      const response = await Decisions.getDecision(anketId, decisionId);
      this.decision = response.data;
      this.fetchState = 'fulfilled';
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }

  @action.bound
  async updateDecision(anketId, decisionId, data) {
    this.fetchState = 'pending';

    try {
      await Decisions.updateDecision(anketId, decisionId, data);
      this.fetchState = 'fulfilled';
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const decisionStore = new DecisionStore();

export default decisionStore;
